/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkDeliveredRequest
 */
export interface MarkDeliveredRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkDeliveredRequest
     */
    shipmentId: string;
}

/**
 * Check if a given object implements the MarkDeliveredRequest interface.
 */
export function instanceOfMarkDeliveredRequest(value: object): value is MarkDeliveredRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    return true;
}

export function MarkDeliveredRequestFromJSON(json: any): MarkDeliveredRequest {
    return MarkDeliveredRequestFromJSONTyped(json, false);
}

export function MarkDeliveredRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkDeliveredRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
    };
}

  export function MarkDeliveredRequestToJSON(json: any): MarkDeliveredRequest {
      return MarkDeliveredRequestToJSONTyped(json, false);
  }

  export function MarkDeliveredRequestToJSONTyped(value?: MarkDeliveredRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
    };
}

